/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ILabelStyles } from '@fluentui/react/lib/Label';
import { IPivotStyles } from '@fluentui/react/lib/Pivot';
import { IStackItemStyles, IStackStyles, IStackTokens } from '@fluentui/react/lib/Stack';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';

import { FontSizes } from '../../../styles/teams';

export const getPivotStyles = (): Partial<IPivotStyles> => {
    return {
        root: { display: 'none' },
        itemContainer: {
            width: '100%',
            height: '100%',
            selectors: {
                '&>div': {
                    width: '100%',
                    height: '100%',
                },
            },
        },
    };
};

export const getPageStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            height: '100%',
            padding: '1.7rem 2rem 2.3rem 2rem',
        },
    };
};

export const getTitleStyles = (theme: ITheme): Partial<ILabelStyles> => {
    return {
        root: {
            color: theme.palette.black,
            fontSize: FontSizes.size18,
            fontWeight: FontWeights.bold,
            height: '1.25rem',
            lineHeight: '1.25rem',
            padding: 0,
            marginBottom: '2.5rem',
        },
    };
};

export const getBodyStyles = (): Partial<IStackItemStyles> => {
    return { root: { height: '100%', overflowX: 'hidden', overflowY: 'auto' } };
};

export const getBodyTokens = (): Partial<IStackTokens> => {
    return { childrenGap: '0.625rem' };
};

export const getListContainerStyles = (): Partial<IStackStyles> => {
    return { root: { marginBottom: '2px' } };
};
